import './entry'
import { app } from './app'

if (
  !process.env.NODE_ENV ||
  ['local', 'development'].includes(process.env.NODE_ENV)
) {
  import('@vue/devtools').then(({ devtools }) => {
    devtools.connect()
  })

  // Move webpack overlay to parent window when in iframe
  if (window.self !== window.top) {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.id === 'webpack-dev-server-client-overlay') {
            try {
              // Remove from iframe
              node.remove()
              // Append to parent document body
              window.top.document.body.appendChild(node)
            } catch (_e) {
              console.warn(
                'Cannot access parent window due to CORS restrictions'
              )
            }
          }
        })
      })
    })

    observer.observe(document.body, {
      childList: true,
      subtree: false
    })
  }
}

// Mount the app
app.mount('#app')
